/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_FailedInputs */

const en_auth_failed = /** @type {(inputs: Auth_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That didn't work. Please try again.`)
};

const de_auth_failed = /** @type {(inputs: Auth_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das hat nicht geklappt. Bitte versuche es erneut.`)
};

/**
* | output |
* | --- |
* | "That didn't work. Please try again." |
*
* @param {Auth_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_failed = /** @type {((inputs?: Auth_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_failed(inputs)
	return en_auth_failed(inputs)
});